import React from 'react';
import { packItems } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-204" data-mp="yvr11dwvo5qs">
      <div className="mx-auto max-w-4xl" data-id="element-205" data-mp="yto8on8960iw">
        <span className="block text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-206" data-mp="kx13xya2662f">
          Co jest w środku?
        </span>
        <h2 className="mt-5 text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-207" data-mp="pxf7p44mmtun">
          Co znajdziesz w pakiecie PLASTYKA GOTOWA™?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-208" data-mp="fyzix7t2nwob">
          {packItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex flex-col rounded-2xl bg-sand px-6 py-8 text-center" data-id="element-209" data-mp="75cp3n8fd3hr">
                <span className="mx-auto inline-flex h-10 w-10 items-center justify-center rounded-full bg-white text-brand" data-id="element-210" data-mp="3tbrqtxfon0zv">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-211" data-mp="3csuvmv5ykmpq" />
                </span>
                <h3 className="mt-4 font-display text-base font-bold text-ink" data-id="element-212" data-mp="37vmaqmtfe4ks">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-ink/55" data-id="element-213" data-mp="3lu2i8fz43z3z">
                  {item.text}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}